import { Container, Stack, Typography, Paper } from '@mui/material';

const Section = ({ title, children }) => (
  <Stack spacing={1}>
    <Typography variant="h6" fontWeight={800} color="text.primary">
      {title}
    </Typography>
    {children}
  </Stack>
);

const PrivacyPolicyPage = () => (
  <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
    <Paper variant="outlined" sx={{ p: { xs: 2.5, md: 4 } }}>
      <Stack spacing={2.5}>
        <Stack spacing={0.5}>
          <Typography variant="h4" fontWeight={900} color="text.primary">
            Privacy Policy
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Last Updated: December 20, 2025
          </Typography>
          <Typography color="text.secondary">
            This Privacy Policy explains how SmartlyRich.com collects, uses, and shares information.
          </Typography>
        </Stack>

        <Section title="1. Information We Collect">
          <Typography>We may collect:</Typography>
          <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>Information you submit (name, phone, email, ZIP code, etc.).</li>
            <li>Device and browsing data (IP address, pages viewed, browser type).</li>
            <li>Click activity on partner links.</li>
            <li>Data from cookies, pixels, and analytics tools.</li>
          </ul>
          <Typography>We do not intentionally collect data from individuals under 18.</Typography>
        </Section>

        <Section title="2. How We Use Information">
          <Typography>We may use information to:</Typography>
          <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>Connect you with relevant service providers.</li>
            <li>Display personalized offers.</li>
            <li>Improve website performance.</li>
            <li>Detect fraud.</li>
            <li>Comply with legal requirements.</li>
          </ul>
          <Typography>
            If you submit a quote request or call a phone number, your information will be shared with third-party partners who may contact you.
          </Typography>
        </Section>

        <Section title="3. How We Share Information">
          <Typography>We may share information with:</Typography>
          <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>Insurance agencies, carriers, brokers, and service providers.</li>
            <li>Lead buyers and marketing partners.</li>
            <li>Analytics and advertising platforms.</li>
            <li>Compliance and fraud-prevention tools.</li>
            <li>Service providers (hosting, CRM, data storage, etc.).</li>
          </ul>
          <Typography>We do not sell sensitive personal information.</Typography>
        </Section>

        <Section title="4. Cookies and Tracking">
          <Typography>We use cookies, pixels, and tracking technologies to:</Typography>
          <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>Analyze traffic.</li>
            <li>Measure conversions.</li>
            <li>Improve website functionality.</li>
            <li>Power targeted advertising.</li>
          </ul>
          <Typography>You may disable cookies through your browser settings.</Typography>
        </Section>

        <Section title="5. Affiliate Disclosure">
          <Typography>
            SmartlyRich.com is compensated by the companies featured on our site. This may influence placement, ranking, and visibility of offers.
          </Typography>
        </Section>

        <Section title="6. Your Rights (CCPA, GDPR, and Similar Laws)">
          <Typography>Depending on where you live, you may have the right to:</Typography>
          <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>Access your data.</li>
            <li>Delete your data.</li>
            <li>Correct inaccurate information.</li>
            <li>Opt out of certain data sharing.</li>
            <li>Request portability.</li>
          </ul>
          <Typography>
            California residents may opt out of the sale or sharing of personal information using our “Do Not Sell or Share My Personal Information”
            page. EU and UK residents may contact us to exercise GDPR rights.
          </Typography>
        </Section>

        <Section title="7. Data Security">
          <Typography>We use reasonable administrative and technical safeguards but cannot guarantee absolute security.</Typography>
        </Section>

        <Section title="8. Third-Party Websites">
          <Typography>
            We are not responsible for content or privacy practices of external sites. Always review their privacy policies before providing
            information.
          </Typography>
        </Section>

        <Section title="9. Contact Us">
          <Typography>For privacy inquiries or requests:</Typography>
          <Typography>SmartlyRich.com</Typography>
          <Typography>Email: supply@upads.com</Typography>
          <Typography>Address: 4 W Palisade Ave #1267</Typography>
          <Typography>Englewood, NJ 07631</Typography>
          <Typography>United States</Typography>
        </Section>
      </Stack>
    </Paper>
  </Container>
);

export default PrivacyPolicyPage;
